import React, { useEffect, useState } from "react";
import "./TeamcompDashboard.css";

const TeamcompDashboard = () => {
  const [teamcomps, setTeamcomps] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch("https://poke-meta.com/api/teamcomps")
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP Fehler: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => setTeamcomps(data))
      .catch((err) => {
        console.error("Fehler beim Abrufen der Teamcomps:", err);
        setError(err.message);
      });
  }, []);

  // Funktion zum Löschen eines Teams mit Bestätigung
  const handleDeleteTeamcomp = (id) => {
    const confirmDelete = window.confirm(
      "Bist du sicher, dass du dieses Team löschen möchtest?"
    );

    if (!confirmDelete) {
      return; // Abbrechen, wenn der Nutzer auf "Nein" klickt
    }

    fetch(`https://poke-meta.com/api/teamcomps/${id}`, {
      method: "DELETE",
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Fehler beim Löschen: ${res.status}`);
        }
        setTeamcomps(teamcomps.filter((team) => team.id !== id));
      })
      .catch((err) => {
        console.error("Fehler beim Löschen:", err);
        setError(err.message);
      });
  };

  return (
    <div className="teamcomp-dashboard-container">
      <h1 className="teamcomp-dashboard-title">Admin Teamcomp Dashboard</h1>
      {error && <p className="error-message">Fehler: {error}</p>}
      {teamcomps.length === 0 && !error && <p>Lade Teamcomps...</p>}

      {teamcomps.map((team) => (
        <div key={team.id} className="teamcomp-dashboard-box">
          <p className="teamcomp-dashboard-rating">Bewertung: {team.rating}</p>
          <div className="teamcomp-dashboard-grid">
            {team.pokemon_list.map((img, i) => (
              <div key={i} className="teamcomp-dashboard-grid-cell">
                <img src={img} alt="Pokémon" className="teamcomp-dashboard-image" />
              </div>
            ))}
          </div>
          <button
            className="delete-button"
            onClick={() => handleDeleteTeamcomp(team.id)}
          >
            Löschen
          </button>
        </div>
      ))}
      
    </div>
  );
};

export default TeamcompDashboard;
